<div class="order-edit-detail-container" id="materials">
  <!-- only show if there are ordered materials -->
  <app-relocation-edit-material
    *ngIf="editMaterial"
    [saving]="panelStatus.busy"
    [definitions]="definitions"
    [material]="editMaterial"
    [panelStatus]="panelStatusMaterial"
    [materialTypes]="materialTypes"
    (nextClicked)="nextClickedFn()"
    (saveMaterialClicked)="saveMaterialClickedFn($event)"
  >
  </app-relocation-edit-material>

  <app-relocation-material-lines
    [materials]="florderDetail.materials"
    [definitions]="definitions"
    [panelStatus]="panelStatusMaterial"
    [readonly]="!panelStatus.isEdit"
    titlePart="MATERIAL_LINES"
    (editMaterialClicked)="editMaterialClicked($event)"
    (removeMaterialClicked)="removeMaterialClicked.emit($event)"
  >
  </app-relocation-material-lines>

  <div class="form-container">
    <div class="hr" *ngIf="panelStatus.isEdit"></div>
    <div class="buttons save-button" *ngIf="panelStatus.isEdit">
      <div class="hr-thick"></div>
      <eps-button
        type="link"
        *ngIf="panelStatus.isNew"
        (buttonClick)="cancelClicked.emit()"
        label="SHARED.BUTTONS.CANCEL"
      ></eps-button>
      <eps-button
        [disabled]="!isValid() || panelStatus?.saving"
        (buttonClick)="nextClickedFn()"
        buttonIcon="check"
        [submit]="isValid() && !panelStatus?.saving && (nextOnEnterPressed$ | async)"
        [label]="panelStatus.isNew ? 'ORDERS.DETAIL.BUTTONS.NEXT' : 'ORDERS.DETAIL.BUTTONS.SAVE'"
      ></eps-button>
    </div>
  </div>
</div>
